<template>
    <div>
        <el-tooltip class="item" effect="dark" :content="$t('Filter_per_Entity')" placement="left" popper-class="popper-cls">
            <span class="entityTree" @click="show = true">
                <img :src="entity_icon" class="entity-icon">
            </span>
        </el-tooltip>
        <el-drawer
            class="drawer-wrapper"
            :title="$t('COMMON_ENTITY')"
            :modal="false"
            :append-to-body="false"
            :visible.sync="show"
            direction="rtl"
            size="440px"
            :before-close="beforeClose"
        >
            <el-input :placeholder="$t('ENTER_SEARCH_CONTENT')" v-model="filterText" clearable> </el-input>
            <div class="item-row select-all-row">
                <div class="select-all-item is" @click="selectAll">{{ $t('select_all') }}</div>
                <div class="select-all-item no" @click="unSelectAll">{{ $t('unselect_all') }}</div>
            </div>
            <div
                class="item-row"
                v-for="(v, k) in showEntityList"
                :key="k">
                <el-checkbox v-model="v.selected" :disabled="v.id == currentEntity">{{ v.entityName }}</el-checkbox>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ItuEntity',
    props: {
        onClose: {
            type: Function,
            default: () => {}
        },
        entities: {
            type: Array,
            default: () => []
        },
        currentEntity: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: false,
            entitiesHere: [],
            filterText: '',
            entity_icon: require(`@/assets/img/icon-entity.svg`)
        }
    },
    mounted() {
        this.entitiesHere = JSON.parse(JSON.stringify(this.entities))
    },
    methods: {
        beforeClose() {
            this.show = false
        },
        selectAll() {
            this.showEntityList.forEach(v => {
                this.entitiesHere.find(vv => vv.id == v.id).selected = true
            })
        },
        unSelectAll() {
            this.showEntityList.filter(v => v.id != this.currentEntity).forEach(v => {
                this.entitiesHere.find(vv => vv.id == v.id).selected = false
            })
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getEntityIds: 'getEntityIds'
        }),
        showEntityList() {
            return this.entitiesHere.filter(v => {
                return v.entityName.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
            })
        }
    },
    watch: {
        entities: {
            deep: true,
            handler(v) {
                this.entitiesHere = v
            }
        },
        entitiesHere: {
            deep: true,
            handler(v) {
                this.$emit('update:entities', v)
            }
        }
    }
}
</script>
<style scoped>
.drawer-wrapper ::v-deep .el-drawer .el-drawer__header {
    font-size: 18px;
    font-weight: bold;
}

.item-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 20px;
    margin-bottom: 10px;
}
.select-all-row {
    margin: 10px 0;
    justify-content: flex-end;
}
.select-all-row .select-all-item {
    margin-right: 10px;
    color: #409eff;
    cursor: pointer;
}
</style>
<style>
.popper-cls.el-tooltip__popper {
    font-size: 12px;
}
.entityTree {
    position: fixed;
    z-index: 2001;
    top: 280px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    font-size: 16px;
    text-align: center;
    background: #7213ea;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    transition: right 0.3s cubic-bezier(0.9, 0, 0.3, 0.7);
    pointer-events: auto;
    color: #ffff;
}
.entity-list-tree-node {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
}
.entity-list-tree-node .extra-area {
    margin-right: 5px;
    color: #409eff;
    align-self: center;
}
.extra-area {
    position: absolute;
    right: 2px;
}
.treeWithEntity .isActive {
    color: #409eff;
}
.wl-container .el-dialog__wrapper .el-drawer .el-drawer__body .el-input {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
}
.wl-container .el-dialog__wrapper .el-drawer .el-drawer__body .el-input__inner {
    width: 95%;
}
.wl-matter-log-container .el-dialog__wrapper .el-drawer .el-drawer__body .el-input {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
}
.wl-matter-log-container .el-dialog__wrapper .el-drawer .el-drawer__body .el-input__inner {
    width: 95%;
}
.el-tree > .el-tree-node {
    min-width: 100%;
    display: inline-block;
}
</style>
